module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "panel panel-default",
    class: {
      fullcav: !!this.fullcav, unbg: !!this.unbg
    }
  }, [(_vm.hashead) ? _c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.header) + "\n\t\t"), _vm._t("title"), _vm._v(" "), (!!_vm.tooltip) ? _c('ul', {
    staticClass: "list-inline pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('icon', {
    attrs: {
      "icon": "zheqi"
    }
  })]), _vm._v(" "), _c('li', [_c('icon', {
    attrs: {
      "icon": "gongdan"
    }
  })]), _vm._v(" "), _c('li', [_c('icon', {
    attrs: {
      "icon": "tuichu"
    }
  })])]) : _vm._e()], true) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!!_vm.show) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._t("body")], true) : _vm._e()]), _vm._v(" "), (!!_vm.footer) ? _c('div', {
    staticClass: "panel-footer"
  }, [_vm._t("footer")], true) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5c71ebb4!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/panel.vue
// module id = 317
// module chunks = 2